module.exports = __webpack_public_path__ + "static/media/eu-flag.27d0655b.svg";